/**
 * <Loading 
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 *
 *
 * @parent anybody
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import './Loading.scss';
import Transition from 'components/UI/Transition';
import { PanelCurtain } from 'components/UI/PanelWrapper'

const DEFAULT_DELAY = 500;

const DEFAULT_TYPE = 'ring';

class Loading extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    onPanel: PropTypes.bool,
    useCurtain: PropTypes.bool,
    curtainStyle: PropTypes.object,
  }

  constructor(props) {
    super(props);

    __addPrimary('Loading', 'FWEQ34', require('./CN'));

    this.state = {}

  }

  componentDidMount() {

    let parentHeight = this.elem.parentNode.parentNode.clientHeight;

    if (parentHeight) {
      this.setState({
        height: parentHeight,
      });
    }
  }
  
  render() {
    let {
      onPanel,
      useCurtain,
      curtainStyle = {},
      type = DEFAULT_TYPE,
      zoom = 1,
      title,
    } = this.props;

    let {
      height,
    } = this.state;

    curtainStyle.height = curtainStyle.height || height;

    let LOGO;
    
    if (type == 'logo') {
      LOGO = (
        <div>
          <img src={require('./imgs/icon_blue.png')}/>
          <h3>{__('Loading...', 'Loading')}</h3>
        </div>  
      ); 
    } 

    if (type == 'ring') {
      LOGO = <div className={'lds-ring'} style={{ transform: `scale(${zoom})` }}><div></div><div></div><div></div><div></div></div>
    }

    if (type == 'facebook') {
      LOGO = <div className={'lds-facebook'}><div></div><div></div><div></div></div>
    }

    const Loading = (
      <Transition type='fade'>
        <div className={classnames('classtop-loading')} style={{height}} ref={(s)=>{ this.elem = s; }}>
            <div className='loading-content'>
              { useCurtain && <div className='loading-curtain' style={curtainStyle} ></div> }
              <div className='loading-icon'>
                {LOGO}
                {title && <h3>{title}</h3>}
              </div>
            </div>
        </div>
      </Transition>
      );

    if (onPanel === true) {
      return <PanelCurtain>{Loading}</PanelCurtain>
    } else {
      return Loading;
    }
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/UI/Loading/index.js